module.exports = __webpack_public_path__ + "img/search.41e36f56.svg";